<template>
  <span class="flex items-center rounded px-1 py-0.5">
    <slot />
  </span>
</template>
